import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { ConnectJobModel } from "services/api/cplapi/CPLAPI";
import { RootState } from "setup";
import { SERVICE_TYPES } from "setup/dependency/ServiceTypes";
import { container } from "setup/dependency/inversify.config";
import { IJobsService } from "services/JobsService";

type JobStateType = {
  Job: ConnectJobModel;
  LoadingJob: boolean;
};

const initialState: JobStateType = {
  Job: new ConnectJobModel({
    orderID: "",
    developmentNumber: "",
    developmentName: "",
    apportionmentDescription: "",
  }),
  LoadingJob: false,
};

export const jobSlice = createSlice({
  name: "job",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(getJob.pending, (state) => {
        state.LoadingJob = true;
      })
      .addCase(getJob.rejected, (state) => {
        state.LoadingJob = false;
      })
      .addCase(getJob.fulfilled, (state, action) => {
        state.LoadingJob = false;
        state.Job = action.payload;
      });
  },
});

export const getJob = createAsyncThunk<ConnectJobModel, { jobID: number; taskSeqID: number }>(
  "Job/GetJob",
  async ({ jobID, taskSeqID }) => {
    const jobsService = container.get<IJobsService>(SERVICE_TYPES.JobsService);
    return await jobsService.getJob(jobID, taskSeqID);
  }
);

export const selectLoadingJob = (state: RootState) => {
  return state.job.LoadingJob;
};

export const selectJob = (state: RootState) => {
  return state.job.Job;
};

export default jobSlice.reducer;
